// Size guide unit toggle + fit tabs.
//
// Delegated from the document so a single module handles every .ko-size-guide on the page
// — the accordion row, the popup and the standalone page can all render at once — and so
// controls keep working after a section re-render (variant change, cart update).

/**
 * @param {Element} guide
 * @param {string} unit - 'cm' or 'in'
 */
function setUnit(guide, unit) {
  guide.setAttribute('data-unit', unit);
  for (const button of guide.querySelectorAll('.ko-size-toggle button')) {
    button.classList.toggle('active', button.dataset.unit === unit);
  }
}

/**
 * @param {Element} guide
 * @param {HTMLElement} tab
 */
function setTab(guide, tab) {
  const id = tab.dataset.tab;

  for (const button of guide.querySelectorAll('.ko-fit-tabs button')) {
    button.classList.toggle('active', button === tab);
  }
  for (const panel of guide.querySelectorAll('.ko-fit-panel')) {
    // Must be the literal string "true" — the CSS matches [data-active='true'], and
    // toggleAttribute would set an empty value that never matches.
    if (panel.dataset.panel === id) {
      panel.setAttribute('data-active', 'true');
    } else {
      panel.removeAttribute('data-active');
    }
  }

  guide.setAttribute('data-active-units', tab.dataset.units ?? 'false');

  // Show only the conversion chart the active tab references (its `conversion`
  // metaobject field); tabs without a reference show none.
  for (const chart of guide.querySelectorAll('.ko-conversion')) {
    if (tab.dataset.conversion && chart.dataset.conversionChart === tab.dataset.conversion) {
      chart.setAttribute('data-active', 'true');
    } else {
      chart.removeAttribute('data-active');
    }
  }
}

document.addEventListener('click', (event) => {
  const target = event.target;
  if (!(target instanceof Element)) return;

  const button = target.closest('.ko-size-toggle button, .ko-fit-tabs button');
  if (!(button instanceof HTMLElement)) return;

  const guide = button.closest('.ko-size-guide');
  if (!guide) return;

  if (button.dataset.unit) {
    setUnit(guide, button.dataset.unit);
  } else if (button.dataset.tab) {
    setTab(guide, button);
  }
});